import gql from "graphql-tag";

export default gql`
  mutation CreateShipmentLazadaBookingFile($_id: ID!) {
    createShipmentLazada(_id: $_id) {
      _id
    }
  }
`;
